/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material'
import Autocomplete, {
  AutocompleteProps,
  AutocompleteRenderInputParams,
} from '@mui/material/Autocomplete'
import { ChipTypeMap } from '@mui/material/Chip'
import React, { useCallback } from 'react'
import { SelectOption } from '../SelectField'
import TextField from '../TextField'

interface IDropdownFieldProps<
  TValue = any,
  IMutiple extends boolean | undefined = undefined,
  IDisableClearble extends boolean | undefined = undefined,
  IFreeSolo extends boolean | undefined = undefined,
  IChipComponent extends React.ElementType = ChipTypeMap['defaultComponent'],
> extends Omit<
    AutocompleteProps<
      TValue,
      IMutiple,
      IDisableClearble,
      IFreeSolo,
      IChipComponent
    >,
    'renderInput' | 'onBlur' | 'options'
  > {
  helperText?: string
  error?: boolean
  label?: string
  name?: string
  onBlur?:
    | React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined
  renderInput?: (params: AutocompleteRenderInputParams) => JSX.Element
  options: Array<SelectOption<string | number>>
  searchable?: boolean
}

const DropdownField = ({
  label,
  renderInput,
  name,
  onBlur,
  error,
  helperText,
  options,
  searchable = true,
  ...rest
}: IDropdownFieldProps) => {
  const defaultRenderInput = useCallback(
    (params: AutocompleteRenderInputParams) => {
      return (
        <TextField
          {...params}
          onBlur={onBlur}
          name={name}
          disabled={!searchable}
          error={error}
          helperText={helperText}
          label={label}
          sx={{
            '& input': {
              padding: '0px !important',
            },
          }}
        />
      )
    },
    [onBlur, name, error, helperText, label, searchable]
  )
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Autocomplete
        {...rest}
        renderInput={renderInput || defaultRenderInput}
        options={options}
      />
    </Box>
  )
}

export default DropdownField
